<sh-page theme="light">
  <sh-pane slot='left' label='Example Queries' max-resize-width="75%" behavior="collapse" arrow-position="center">
    <sh-list class="rounded-list">
      <sh-list-item divider="full-width" clickable (click)="fillInput('How to replace DAFID?')">How to replace DAFID?</sh-list-item>
    </sh-list>
  </sh-pane>
  <sh-card>
    <div class="centered-container">
      <div class="center-content search-section">
        <sh-text size='super-header'>Professional Multi-Agent Assistant</sh-text>
        <sh-divider></sh-divider>
        <div class="dropdown-row">
          <sh-dropdown items='4' label='Select Modality' [error]="modalityError" error-message="Please select a modality" editable>
            <sh-menu-item *ngFor="let modality of modalities" [label]="modality" (click)="onModalityChange(modality)" [active]="selectedModality === modality"></sh-menu-item>
          </sh-dropdown>
          <sh-dropdown items='4' label='Select Product Title' [error]="productError" error-message="Please select a product" editable [disabled]="!selectedModality || selectedModality === 'All'">
            <sh-menu-item *ngFor="let product of filteredProducts" [label]="product" (click)="onProductChange(product)" [active]="selectedProduct === product"></sh-menu-item>
          </sh-dropdown>
        </div>
        <sh-input-text textarea rows='6' label='Enter your query here' [value]="queryInput" (value-changed)="onQueryInput($event)"></sh-input-text>
        <sh-text size='body-1' *ngIf="!isModalitySupported" class="validation-message">Modality not supported</sh-text>
        <sh-text size='body-1' [style.display]="showValidationMessage ? '' : 'none'" class="validation-message">{{validationMessage}}</sh-text>
        <div class="button-row">
          <sh-button label='Submit' appearance='primary' size='m' (click)="processInput()" [disabled]="showSpinner || !isModalitySupported"></sh-button>
          <sh-button label='Clear' color='secondary' appearance='secondary' size='m' (click)="clearInput()"></sh-button>
        </div>
        <sh-spinner label='Processing Query' size="s" [style.display]="showSpinner ? '' : 'none'"></sh-spinner>     
      </div>
    </div>
    
    <div class="response-container">
      <div class="response-content-box">
        <sh-text size="super-header">Response</sh-text>
        <sh-box background="surface" layout="vertical" content-gap="1">
          
          <div class="no-results-container" *ngIf="showResponse && (!hasResults() || hasError())">
            <sh-text size="header-3" class="no-results-message">
              {{ hasError() ? searchError : 'No relevant data available for your query.' }}
            </sh-text>
          </div>
          
          <div *ngIf="showResponse && hasResults() && !hasError()">
            <sh-text size="header-2">Found {{hybridResults.length}} Result{{hybridResults.length > 1 ? 's' : ''}}</sh-text>
          </div>
          
          <!-- Accordion sections for hybrid search results -->
          <div class="sections-container" *ngIf="showResponse && hasResults() && !hasError()">
            <div *ngFor="let result of hybridResults; let i = index">
              <sh-accordion icon='document' [label]="getHybridResultLabel(result, i)" class="section-accordion" [class.section-accordion--visited]="visitedResults.has(i)" (click)="markAsVisited(i)">
                <div class="section-content">
                  <div class="section-metadata">
                    <sh-text size="body-2" class="metadata-item">
                      <strong>Score:</strong>
                      <span [ngClass]="getScoreClass(result.score)">{{ getScoreText(result.score) }}</span>
                    </sh-text>
                    <sh-text size="body-2" class="metadata-item">
                      <strong>Document Title:</strong> {{result.document_title || 'N/A'}}
                    </sh-text>
                    <sh-text size="body-2" class="metadata-item">
                      <strong>Section:</strong> {{result.section_label || 'N/A'}}
                    </sh-text>
                    <sh-text size="body-2" class="metadata-item">
                      <strong>Section Title:</strong> {{result.section_title || 'N/A'}}
                    </sh-text>
                    <sh-text size="body-2" class="metadata-item">
                      <strong>Modality:</strong> {{result.modalityAcronym || 'N/A'}}
                    </sh-text>
                    <sh-text size="body-2" class="metadata-item">
                      <strong>Product Title:</strong> {{result.productTitle || 'N/A'}}
                    </sh-text>
                    <sh-text size="body-2" class="metadata-item">
                      <strong>Info Class:</strong> {{result.infoclassname || 'N/A'}}
                    </sh-text>
                    <sh-text size="body-2" class="metadata-item" *ngIf="result.website_url">
                      <strong>Website URL:</strong> <a [href]="result.website_url" target="_blank">{{result.website_url}}</a>
                    </sh-text>
                  </div>
                  <sh-divider></sh-divider>
                  <div class="section-text">
                    <sh-text size="body-2"><strong>Content:</strong></sh-text>
                    <markdown [data]="truncateText(result.body, 8000)"></markdown>
                    <div class="section-actions" *ngIf="result.website_url">
                      <a [href]="result.website_url" target="_blank" class="doc-link">
                        Click for full document
                      </a>
                    </div>
                  </div>
                </div>
              </sh-accordion>
            </div>
          </div>
        </sh-box>
        
      </div>
    </div>

  </sh-card>  
</sh-page>
